const productSearch = () => {
	const productSearch = document.querySelector('.js-product-search-form');

	if (productSearch) {
		const input = productSearch.querySelector('.js-input-search-prod');
		const resultsBox = productSearch.querySelector('.js-result-box');
		const blogForm = productSearch.querySelector('.js-form-search');
		const textSearch = productSearch.getAttribute('data-textSearch');
		const textLoad = productSearch.getAttribute('data-textLoad');
		const archiveLink = productSearch.getAttribute('data-archiveLink');

		blogForm.addEventListener('submit', (e) => {
			e.preventDefault();
			e.stopPropagation();

			if (input.value !== '') {
				window.location.href = `${archiveLink}?s=${input.value}`;
			}
		});

		input.addEventListener('focusout', (e) => {
			setTimeout(() => {
				productSearch.classList.remove('active');
				resultsBox.innerHTML = '';
			}, 100);
		});

		input.addEventListener('input', (e) => {
			const val = input.value.trim();

			if (val.length >= 3) {
				resultsBox.innerHTML = textLoad;
				productSearch.classList.add('active');
				resultsProductSearch(val);
			} else {
				resultsBox.innerHTML = textSearch;
				productSearch.classList.add('active');
			}
		});

		const resultsProductSearch = (term) => {
			const ajax = new XMLHttpRequest();
			const formData = new FormData();
			const nonce = productSearch.querySelector('.js-input-nonce');

			formData.append('action', 'product_wcsu_search');
			formData.append('search', term);

			if (nonce) {
				formData.append('nonce', nonce.value);
			}

			ajax.open('POST', globalVars.ajaxUrl, true);

			ajax.onreadystatechange = () => {
				if (ajax.readyState === 4 && ajax.status === 200) {
					if (ajax.responseText) {
						const json = JSON.parse(ajax.responseText);
						resultsBox.innerHTML = json.data.html || '';
						productSearch.classList.add('active');
					}
				}
			};

			ajax.send(formData);
		};
	}
};

export default productSearch;
